import { gql, useLazyQuery } from '@apollo/client';

const OPERATION_LINK_DOCUMENT = gql`
    query linkToAudinDocument($report_id: ID!) {
        link: linkToAudinDocument(report_id: $report_id)
    }
`;

export const useLink = () => {
  const [fetch] = useLazyQuery(OPERATION_LINK_DOCUMENT, {
    fetchPolicy: 'network-only',
  });

  return {
    go: async (reportId) => {
      try {
        const { data } = await fetch({ variables: { report_id: reportId } });
        window.open(data.link, '_blank');
      } catch (e) {
        console.log(e);
      }
    },
  };
};

export default useLink;
